// import React, { useRef } from "react";
// import Modal from "react-modal";
// import { Invoice } from "../../layout/invoice";
// import { printDocument } from "../../utils/functions";

// export const SellDetailsModal = ({ isOpen, onRequestClose, sellDetails }) => {
//   const pdfRef = useRef();
//   console.log(sellDetails);
//   if (!sellDetails) return null;

//   const printInvoice = async () => {
//     await printDocument("inv_content");
//   };

//   const handleReturn = (productId, index) => {
//     console.log(
//       `Returning product: ${productId}, Quantity: ${sellDetails.quantity[index]}`
//     );
//     // Here, you can add logic to handle product return (API call, state update, etc.)
//   };

//   return (
//     <Modal
//       isOpen={isOpen}
//       onRequestClose={onRequestClose}
//       contentLabel="Sell Details"
//     >
//       <div ref={pdfRef} className="p-3">
//         <h2 className="text-center">Cash Memo</h2>

//         {/* Sell Details Table */}
//         <table className="table table-bordered">
//           <tbody>
//             <tr>
//               <td>
//                 <strong>Sell ID</strong>
//               </td>
//               <td>{sellDetails.sell_id}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Customer Name</strong>
//               </td>
//               <td>{sellDetails.customer_name}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Customer Address</strong>
//               </td>
//               <td>{sellDetails.customer_address}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Customer Phone Number</strong>
//               </td>
//               <td>{sellDetails.customer_phone_number}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Seller Name</strong>
//               </td>
//               <td>{sellDetails.seller_name}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Seller ID</strong>
//               </td>
//               <td>{sellDetails.seller_id}</td>
//             </tr>
//           </tbody>
//         </table>

//         {/* Product Details Table */}
//         <h3 className="mt-3">Product Details</h3>
//         <table className="table table-striped">
//           <thead>
//             <tr>
//               <th>Product ID</th>
//               <th>Product Name</th>
//               <th>Custom Length</th>
//               <th>Custom Width</th>
//               <th>Quantity</th>
//               <th>Price</th>
//               <th>Total Price</th>
//               <th>Action</th> {/* New Action Column */}
//             </tr>
//           </thead>
//           <tbody>
//             {sellDetails.product_id.map((id, index) => (
//               <tr key={index}>
//                 <td>{id}</td>
//                 <td>{sellDetails.product_name[index]}</td>
//                 <td>{sellDetails.custom_length[index]}</td>
//                 <td>{sellDetails.custom_width[index]}</td>
//                 <td>{sellDetails.quantity[index]}</td>
//                 <td>{sellDetails.price[index]}</td>
//                 <td>
//                   {sellDetails.price[index] * sellDetails.quantity[index]}
//                 </td>
//                 <td>
//                   <button
//                     className="btn btn-warning btn-sm"
//                     onClick={() => handleReturn(id, index)}
//                   >
//                     Return
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Pricing Details Table */}
//         <h3 className="mt-3">Pricing Summary</h3>
//         <table className="table table-bordered">
//           <tbody>
//             <tr>
//               <td>
//                 <strong>Subtotal</strong>
//               </td>
//               <td>{sellDetails.total_price}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Discount</strong>
//               </td>
//               <td>{sellDetails.discount_amount}%</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Carrying Charge</strong>
//               </td>
//               <td>{sellDetails.carring_charge}</td>
//             </tr>
//             <tr>
//               <td>
//                 <strong>Total After Discount</strong>
//               </td>
//               <td>{sellDetails.total_price_after_discount}</td>
//             </tr>
//           </tbody>
//         </table>

//         {/* Action Buttons */}
//         <div className="d-flex">
//           <button
//             onClick={onRequestClose}
//             className="btn btn-danger btn-sm m-1"
//           >
//             Close
//           </button>
//           <button onClick={printInvoice} className="btn btn-primary btn-sm m-1">
//             Print
//           </button>
//         </div>

//         {/* Hidden Invoice Content for Printing */}
//         <div
//           id="inv_content"
//           style={{ minHeight: "max-content", display: "none" }}
//         >
//           <Invoice data={sellDetails} />
//         </div>
//       </div>
//     </Modal>
//   );
// };

import React, { useRef, useState } from "react";
import Modal from "react-modal";
import { Invoice } from "../../layout/invoice";
import { printDocument } from "../../utils/functions";
import axios from "../../api/axios";

export const SellDetailsModal = ({ isOpen, onRequestClose, sellDetails }) => {
  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  console.log(sellDetails);
  if (!sellDetails) return null;

  const printInvoice = async () => {
    await printDocument("inv_content");
  };

  const handleReturn = async (productId, index) => {
    console.log(
      `Returning product: ${productId}, Quantity: ${sellDetails.quantity[index]}`
    );
    setLoading(true);
    setError(null);

    // Prepare data for the return
    const returnData = {
      productId,
      sell_id: sellDetails.sell_id,
      quantity: sellDetails.quantity[index],
      customLength: sellDetails.custom_length[index],
      customWidth: sellDetails.custom_width[index],
      customer_address: sellDetails.customer_address,
      customer_name: sellDetails.customer_name,
      customer_phone_number: sellDetails.customer_phone_number,
      seller_id: sellDetails.seller_id,
    };

    try {
      // Make API call to process the return
      const response = await returnProduct(returnData);

      if (response.status === 200) {
        alert(`Product with ID ${productId} returned successfully`);

        // Optionally update the UI after the return is successful
        // Here, you can trigger a refetch of the sellDetails or update the UI as needed
        // For now, close the modal
        onRequestClose();
      } else {
        throw new Error("Failed to return the product");
      }
    } catch (error) {
      console.error("Error during return:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const returnProduct = async (returnData) => {
    // Make the API call using Axios
    try {
      const response = await axios.put("/update-sell", returnData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response; // Return the response for further handling
    } catch (error) {
      // Handle errors from the API request
      throw new Error(
        error.response?.data?.message || "Failed to process return"
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Sell Details"
    >
      <div ref={pdfRef} className="p-3">
        <h2 className="text-center">Cash Memo</h2>

        {/* Sell Details Table */}
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>
                <strong>Sell ID</strong>
              </td>
              <td>{sellDetails.sell_id}</td>
            </tr>
            <tr>
              <td>
                <strong>Customer Name</strong>
              </td>
              <td>{sellDetails.customer_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Customer Address</strong>
              </td>
              <td>{sellDetails.customer_address}</td>
            </tr>
            <tr>
              <td>
                <strong>Customer Phone Number</strong>
              </td>
              <td>{sellDetails.customer_phone_number}</td>
            </tr>
            <tr>
              <td>
                <strong>Seller Name</strong>
              </td>
              <td>{sellDetails.seller_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Seller ID</strong>
              </td>
              <td>{sellDetails.seller_id}</td>
            </tr>
          </tbody>
        </table>

        {/* Product Details Table */}
        <h3 className="mt-3">Product Details</h3>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Product ID</th>
              <th>Product Name</th>
              <th>Custom Length</th>
              <th>Custom Width</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Total Price</th>
              <th>Action</th> {/* New Action Column */}
            </tr>
          </thead>
          <tbody>
            {sellDetails.product_id.map((id, index) => (
              <tr key={index}>
                <td>{id}</td>
                <td>{sellDetails.product_name[index]}</td>
                <td>{sellDetails.custom_length[index]}</td>
                <td>{sellDetails.custom_width[index]}</td>
                <td>{sellDetails.quantity[index]}</td>
                <td>{sellDetails.price[index]}</td>
                <td>
                  {sellDetails.price[index] * sellDetails.quantity[index]}
                </td>
                <td>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={() => handleReturn(id, index)}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Return"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pricing Details Table */}
        <h3 className="mt-3">Pricing Summary</h3>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>
                <strong>Subtotal</strong>
              </td>
              <td>{sellDetails.total_price}</td>
            </tr>
            <tr>
              <td>
                <strong>Discount</strong>
              </td>
              <td>{sellDetails.discount_amount}%</td>
            </tr>
            <tr>
              <td>
                <strong>Carrying Charge</strong>
              </td>
              <td>{sellDetails.carring_charge}</td>
            </tr>
            <tr>
              <td>
                <strong>Total After Discount</strong>
              </td>
              <td>{sellDetails.total_price_after_discount}</td>
            </tr>
          </tbody>
        </table>

        {/* Action Buttons */}
        <div className="d-flex">
          <button
            onClick={onRequestClose}
            className="btn btn-danger btn-sm m-1"
          >
            Close
          </button>
          <button onClick={printInvoice} className="btn btn-primary btn-sm m-1">
            Print
          </button>
        </div>

        {/* Hidden Invoice Content for Printing */}
        <div
          id="inv_content"
          style={{ minHeight: "max-content", display: "none" }}
        >
          <Invoice data={sellDetails} />
        </div>

        {/* Error Message */}
        {error && <div className="alert alert-danger mt-3">{error}</div>}
      </div>
    </Modal>
  );
};
